import _extends from "@swc/helpers/src/_extends.mjs";
// DS: i1.6
import React from 'react';
import IconWrap from '../../IconWrap';
const Gift = (props)=>/*#__PURE__*/ React.createElement(IconWrap, _extends({}, props), /*#__PURE__*/ React.createElement("svg", {
        width: "0",
        height: "0",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 16h6v5H6a1 1 0 01-1-1v-4zm14 0v4a1 1 0 01-1 1h-5v-5h6zM14.44 3.25c.07.032.165.087.276.16l.243.168c.044.03.089.064.135.098l.346.265.36.293.355.3.325.291.122.114.21.207c.092.096.164.178.208.241a1 1 0 01-.245 1.393L15.032 8H20a1 1 0 011 1v1.5a1 1 0 01-1 1h-1V14h-6V8h-2v6H5v-2.5H4a1 1 0 01-1-1V9a1 1 0 011-1h5.274L7.532 6.78a1 1 0 01-.246-1.393c.044-.062.115-.147.204-.247l.203-.219.305-.31.338-.326.344-.32.247-.219.224-.19a3.1 3.1 0 01.339-.252l.104-.053a1 1 0 011.266.403l.054.104 1.103 2.477 1.103-2.477a1 1 0 011.32-.507z",
        clipRule: "evenodd"
    })));
Gift.displayName = 'Gift';
export default Gift;
